import React, { Component } from 'react';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import Bind from 'lodash-decorators/bind';

import NewsStore from 'stores/News.store';

import LanguageService from 'services/Language.service';

//styles
import styles from './NewsAndEvents.module.scss';

import messages from './NewsAndEvents.intl';

import EventsStore from 'stores/Events.store';
import { Container } from 'common/components/Layout/Layout';

import NewsBox from './Components/NewsBox/NewsBox';
import EventsBox from './Components/EventsBox/EventsBox';

import { ANCHOR } from 'common/consts/common';

const DEFAULT_LIMIT = 3;
const DEFAULT_SKIP = 0;

@injectIntl
@observer
export default class NewsAndEvents extends Component {
  state = {
    latestNews: {
      criteria: {
        publishYear: ''
      },
      pagination: {
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT
      },
      items: [],
      endOfCollection: false
    }
  };

  currentLanguage = LanguageService.getLang();

  componentDidMount() {
    EventsStore.getEvents();
    this.fetchLatestNews();
  }

  @Bind
  async fetchLatestNews() {
    const { criteria, pagination, items } = this.state.latestNews;
    const queriedLatestNews = await NewsStore.fetchLatestNews(
      criteria,
      pagination,
      true
    );

    // immmutable
    const newState = {
      criteria: { ...criteria },
      pagination: {
        limit: DEFAULT_LIMIT,
        skip: pagination.skip + pagination.limit
      },
      items: [...items, ...queriedLatestNews.items],
      endOfCollection: queriedLatestNews.endOfCollection
    };

    this.setState({
      latestNews: newState
    });
  }

  render() {
    const events = EventsStore.events;
    const {
      latestNews: { items }
    } = this.state;

    const latestNews = [...items];
    return (
      <Container>
        <div className={styles.SectionWrapper}>
          <div className={styles.Header}>
            <h3 className={styles.HeaderTitle}>
              {this.props.intl.formatMessage(messages.headingNews)}
            </h3>
            <Link
              to={ANCHOR.NEWS[this.currentLanguage]}
              className={styles.HeaderLink}
            >
              {this.props.intl.formatMessage(messages.headingAllNews)}
            </Link>
          </div>
          <div className={styles.NewsWrapper}>
            <div className={styles.NewsCollapse}>
              {latestNews.map(item => (
                <NewsBox
                  key={item.id}
                  id={item.id}
                  image={item.photo}
                  title={item.title}
                  date={item.publicationDate}
                  slug={item.slug}
                  category={item.category}
                />
              ))}
            </div>
          </div>
          {events.length > 0 && (
            <div className={styles.Header}>
              <h3 className={styles.HeaderTitle}>
                {this.props.intl.formatMessage(messages.headingEvents)}
              </h3>
            </div>
          )}
          {events.length > 0 && (
            <div className={styles.EventsWrapper}>
              {events.map((event, i) => (
                <EventsBox
                  key={event.id}
                  title={event.title}
                  description={event.description}
                  dateDay={event.dateDay}
                  dateMonth={event.dateMonth}
                  dateYear={event.dateYear}
                />
              ))}
            </div>
          )}
        </div>
      </Container>
    );
  }
}

export { DEFAULT_LIMIT };



// WEBPACK FOOTER //
// ./src/views/Home/Sections/NewsAndEvents/NewsAndEvents.js